const NAMESPACE = 'FAUCET';
// Wallet registration inside the Address Book smart contract
export const FAUCET_REQ = `${NAMESPACE}/FAUCET_REQ`;
export const FAUCET_OK = `${NAMESPACE}/FAUCET_OK`;
export const FAUCET_FAIL = `${NAMESPACE}/FAUCET_FAIL`;
export const FAUCET_TX_CONFIRM = `${NAMESPACE}/FAUCET_TX_CONFIRM`;
export const FAUCET_TX_FAIL = `${NAMESPACE}/FAUCET_TX_FAIL`;
